import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CheckCircle2Icon, ClockIcon } from 'lucide-react';
import { getText, isRtl, type Lang } from './translations';
export function DurationRewardSlide({
  onNext,
  onBack,
  lang = 'en' as Lang
}: {
  onNext: () => void;
  onBack: () => void;
  lang?: Lang;
}) {
  const rtl = isRtl(lang);
  return <div className="flex flex-col h-full px-6 py-8 relative z-10 bg-white" dir={rtl ? 'rtl' : 'ltr'} data-id="element-129">
      <div className="flex items-center justify-between mb-6" data-id="element-130">
        <button onClick={onBack} className="p-2 -ml-2 text-slate-400 hover:text-stone-600 transition-colors bg-white rounded-full shadow-sm border border-stone-100" aria-label="Go back" data-id="element-131">
          <ArrowLeftIcon className={`w-5 h-5 ${rtl ? 'rotate-180' : ''}`} data-id="element-132" />
        </button>
      </div>

      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full justify-center pb-12" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8 text-center flex flex-col items-center" data-id="element-134">
          <div className="w-24 h-24 rounded-full overflow-hidden mb-6 border-4 border-white shadow-md" data-id="element-135">
            <img src="https://images.unsplash.com/photo-1501139083538-0139583c060f?q=80&w=1000&auto=format&fit=crop" alt="Time passing" className="w-full h-full object-cover" data-id="element-136" />
          </div>

          <div className="inline-flex items-center space-x-2 rtl:space-x-reverse bg-nhs-blue/10 text-nhs-blue px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide mb-4 border border-nhs-blue/20" data-id="element-137">
            <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-138" />
            <span data-id="element-139">{getText('insight', lang)}</span>
          </div>

          <h2 className="text-2xl font-semibold text-slate-900 leading-tight mb-6" data-id="element-140">
            {getText('durationInsightTitle', lang)}
          </h2>

          <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm text-left space-y-4" dir={rtl ? 'rtl' : 'ltr'} data-id="element-141">
            <p className="text-stone-600 leading-relaxed" data-id="element-142">
              {getText('durationInsightBody', lang)}
            </p>
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} className="mt-auto" data-id="element-143">
        <button onClick={onNext} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-md shadow-nhs-blue/20 active:scale-[0.98]" data-id="element-144">
          {getText('continue', lang)}
        </button>
      </motion.div>
    </div>;
}